import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { COLORS } from "../../COLORS";
import { FaSquareWebAwesome } from "react-icons/fa6";
import { SlBadge } from "react-icons/sl";
import RecentsAnnonces from "./RecentsAnnonces/RecentsAnnonces";
import RecentsEvenements from "./RecentsEvenements/RecentsEvenements";
import Categories from "./Categories/Categories";
import RecompBasic from "../Points/Basic/RecompBasic";
import LilAdsGlobal from "../Ads/LilAdsGlobal";
import Premium from "../Points/Premium/Premium";
import Gold from "../Points/Gold/Gold";
import ParternesGold from "../Ads/Partenaires/ParternesGold";
import { Dynamic } from "../Context/ContextDynamic";
import ThreeAds from "../Ads/ThreeAds/ThreeAds";
import OneAds from "../Ads/OneAds/OneAds";
import { Fade, JackInTheBox, Slide } from "react-awesome-reveal";
import BanniereHome from "./BanniereHome/BanniereHome";
import RaisonsPublish from "./RaisonsPublish/RaisonsPublish";
import Directions from "./Directions/Directions";
import Formules from "../Utils/Formules";

const Home = ({
  setCompo,
}: {
  setCompo: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [compoReturn, setCompoReturn] = useState(0);
  const { partenaires } = Dynamic();
  const displayOneRecomp = () => {
    switch (compoReturn) {
      case 0:
        return <RecompBasic />;
      case 1:
        return <Premium />;
      case 3:
        return <Gold />;
      default:
        return <Gold />;
    }
  };

  const randomCompoToDisplayRecomp = () => {
    const max = 3;
    const value = Math.floor(Math.random() * max);
    setCompoReturn(value);
  };
  useEffect(() => {
    window.scrollTo(0, 0); //pour remonter le scroll
    randomCompoToDisplayRecomp();
  }, []);

  return (
    <StyledHome>
      <Slide direction="down" triggerOnce>
        <BanniereHome />
      </Slide>
      <Slide direction="right" triggerOnce>
        <RecentsAnnonces />
      </Slide>
      {partenaires.length > 0 && (
        <Fade triggerOnce>
          <ThreeAds />
        </Fade>
      )}
      <Slide direction="up" triggerOnce>
        <RaisonsPublish />
      </Slide>
      <Directions />
      {partenaires.length > 0 && <OneAds />}
      {/* <Formules /> */}
      <JackInTheBox triggerOnce>
        <div className="img-en-avant">
          <img src="./items/home/@emohup.png" alt="img-avant" />
        </div>
      </JackInTheBox>
      {/* <Categories /> */}
      {/* <RecentsAnnonces />
      <RecentsEvenements /> */}
    </StyledHome>
  );
};

export default Home;
const StyledHome = styled.section`
  /* background: ${COLORS.blueLow}; */
  border-radius: 10px;
  margin: 0px auto 20px;
  width: 100%;
  .img-en-avant {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    img {
      width: 30%;
    }
  }

  //width =< 429px
  @media screen and (max-width: 445px) {
    margin-top: 50px;
    /* padding-top: 30px; */
    width: 100%;
    .img-en-avant {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      img {
        width: 80%;
      }
    }
  }
`;
